module.exports = __webpack_public_path__ + "img/kx5200.cd92b7f0.png";